export default __webpack_public_path__ + "static/media/confirmIllustration.d7302000.svg";